export const contentData = {
  spanish:{
    nodata:'Sin Registro',
    tableTitle:'Usuarios',
    header:['ID','Usuario','Contraseña','Token','Tipo de Token','Responsable','Carta de uso', ],
    modals:{
      warning_delete_item:{
        title:'¿Estás seguro?',
        message:'¿Realmente quieres eliminar este registro? Este proceso no puede ser revertido',
        cancelButton:'Cancelar',
        deleteButton:'Eliminar'
      },
      cerl:{
        name:'Certificado eFirma',
        button:'Guardar',
        cancelButton:'Cancelar'
      }
    },
  },
  english:{

  }
}